export default __webpack_public_path__ + "static/media/github avatar.2ee65349.png";